export default __webpack_public_path__ + "static/media/aeromexico.c68c5717.svg";